import * as React from 'react';
import { useState, useEffect } from 'react';

/** Material UI Packages. */
import { Box, Paper, Tabs, Tab } from '@mui/material';

/** Internal Components. */
import { customized_style } from 'shared/config/Styles';
import TabPanel from 'shared/ui/TabPanel';

import UserActivity from './components/UserActivity';

export default function Activity() {
    /** State for the selected value of tabs. */
    const [tabValue, setTabValue] = useState(0);

    /** Named website title. */
    useEffect(() => {
        document.title = 'User Activity | Operation System';
    }, []);

    return (
        <>
            <Paper sx={{ ...customized_style.itemPaper, p: 0 }}>
                <Tabs
                    value={tabValue}
                    onChange={(event, newValue) => setTabValue(newValue)}
                    variant="fullWidth"
                    aria-label="data entry tabs"
                    sx={{
                        borderBottom: 1,
                        borderColor: '#d2d2d4',
                    }}
                >
                    <Tab label="USER ACTIVITY" />
                    <Tab label="SYSTEM ACTIVITY" />
                </Tabs>
                <TabPanel value={tabValue} index={0}>
                    <Box sx={{ p: 1 }}>
                        <UserActivity tabValue={tabValue} />
                    </Box>
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <Box sx={{ p: 1 }}>
                        <UserActivity tabValue={tabValue} />{' '}
                    </Box>
                </TabPanel>
            </Paper>
        </>
    );
}
